import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Package, Truck } from "lucide-react"
import Button from "../../common/Button.js"

const DashboardQuickActionButtons = ({ hubBookingAllowed }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <>
      {hubBookingAllowed && (
        <Button
          variant="primary"
          mobileIconOnly
          mobileLabel={t("dashboard.booking")}
          icon={Package}
          onClick={() => navigate("/shipments/add")}
        >
          {t("dashboard.booking")}
        </Button>
      )}
      <Button
        variant="orange"
        mobileIconOnly
        mobileLabel={t("dashboard.dispatch")}
        icon={Truck}
        onClick={() => navigate("/ml-sheets/add")}
      >
        {t("dashboard.dispatch")}
      </Button>
    </>
  )
}

export default DashboardQuickActionButtons
